import { createContext, useContext } from 'react';
import type { Api } from '../api/client';
import type { UserItem } from '../types';

export interface AdminContextValue {
  api: Api;
  me: UserItem;
  refreshMe: () => Promise<void>;
}

export const AdminContext = createContext<AdminContextValue | null>(null);

export function useAdmin(): AdminContextValue {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used inside the admin area');
  return ctx;
}
